<template>
  <!-- 数据源配置 -->
  <el-dialog
    :visible.sync="dialogFormVisible"
    :append-to-body="true"
    :close-on-click-modal="false"
    title="数据源配置"
    top="10vh"
  >
    <div>
      <div class="filter-container">
        <el-input
          v-trim
          v-model="listQuery.data_name"
          placeholder="数据源名称"
          clearable
          filterable
          style="width: 200px;"
          class="filter-item"
          @keyup.enter.native="handleFilter"
        />
        <el-input
          v-trim
          v-model="listQuery.data_source_code"
          placeholder="数据源code"
          clearable
          filterable
          style="width: 200px;"
          class="filter-item"
          @keyup.enter.native="handleFilter"
        />
        <el-input
          v-trim
          v-model="listQuery.api_name"
          placeholder="接口"
          clearable
          filterable
          style="width: 200px;"
          class="filter-item"
          @keyup.enter.native="handleFilter"
        />
        <el-input
          v-trim
          v-model="listQuery.data_desc"
          placeholder="备注"
          clearable
          filterable
          style="width: 200px;"
          class="filter-item"
          @keyup.enter.native="handleFilter"
        />
        <el-input
          v-trim
          v-model="listQuery.create_user_name"
          placeholder="创建人"
          clearable
          filterable
          style="width: 200px;"
          class="filter-item"
          @keyup.enter.native="handleFilter"
        />
        <el-button
          v-waves
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
        >搜索</el-button
        >
        <el-button
          v-waves
          class="filter-item"
          type="primary"
          icon="el-icon-plus"
          @click="handleAdd"
        >新增</el-button
        >
      </div>
      <el-table
        v-loading="listLoading"
        ref="multipleTable"
        :key="tableKey"
        :data="list"
        border
        fit
        stripe
        highlight-current-row
        style="width: 100%;"
        height="50vh"
        class="tableStyle2"
        header-cell-class-name="headerstyle2"
        @row-click="handleRowClick"
        @row-contextmenu="openMenu"
        @selection-change="handleSelectionChange"
        @sort-change="sortChange"
      >
        <el-table-column type="selection" width="40px"/>
        <el-table-column
          label="操作"
          prop="field_code"
          align="center"
          width="50px"
        >
          <template slot-scope="scope">
            <i
              class="el-icon-edit ico pointer"
              @click.stop="handleEditBtn(scope.row)"
            ></i>
            <i
              class="el-icon-delete ico pointer"
              style="color:#b74747"
              @click.stop="handleDel(scope.row.id)"
            ></i>
          </template>
        </el-table-column>
        <el-table-column
          label="数据源名称"
          prop="data_name"
          sortable
          width="120px"
        />
        <el-table-column
          label="数据源code"
          prop="data_source_code"
          width="200px"
          sortable
        />
        <el-table-column label="接口" prop="api_name" width="220px" sortable/>
        <el-table-column label="请求方式" prop="method" />
        <el-table-column label="参数" prop="param_json" width="350px" sortable/>
        <el-table-column
          label="显示字段"
          prop="show_field_name"
          width="100px"
          sortable
        />
        <el-table-column
          label="值字段"
          prop="value_field_name"
          width="100px"
          sortable
        />
        <el-table-column
          label="关键字"
          prop="keyword"
          width="100px"
          sortable
        />
        <el-table-column label="备注" prop="data_desc" width="74px" sortable/>
        <el-table-column
          label="创建人"
          prop="create_user_name"
          width="80px"
          sortable
        />
        <el-table-column
          label="创建时间"
          prop="create_time_yyyymmdd"
          width="140px"
          sortable
        />
        <el-table-column
          label="更新人"
          prop="update_user_name"
          width="80px"
          sortable
        />
        <el-table-column
          label="更新时间"
          prop="update_time_yyyymmdd"
          width="140px"
          sortable
        />
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page_no"
        :limit.sync="listQuery.page_size"
        @pagination="getList"
      />
      <Contextmenu ref="menu">
        <div slot="menuList">
          <el-dropdown-item size="mini" icon="el-icon-document-copy" @click.native="handleCopy(activeTableRow)">
            <span>复制</span>
          </el-dropdown-item>
        </div>
      </Contextmenu>
      <div class="footer">
        <span slot="footer" class="dialog-footer">
          <el-button
            v-waves
            @click="dialogFormVisible = false"
          >取 消</el-button
          >
          <el-button
            v-waves
            type="primary"
            @click="handleSure"
          >确 定</el-button
          >
        </span>
      </div>
      <el-dialog
        :title="type == 'create' ? '新增' : '编辑'"
        :visible.sync="dialogVisible"
        :append-to-body="true"
        width="40%"
      >
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="dataForm"
          label-position="right"
          label-width="100px"
          size="medium"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="数据源名称" prop="data_name">
                <el-input
                  v-trim
                  v-model="ruleForm.data_name"
                  placeholder="请输入数据源名称"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="数据源code" prop="data_source_code">
                <el-input
                  v-trim
                  v-model="ruleForm.data_source_code"
                  placeholder="请输入数据源code"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="接口" prop="api_name">
                <el-input
                  v-trim
                  v-model="ruleForm.api_name"
                  placeholder="请输入接口"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="请求方式" prop="method">
                <el-select v-trim v-model="ruleForm.method" placeholder="请选择请求方式" class="filter-item w100">
                  <el-option
                    v-for="item in baseInfo['HttpMethod']"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="参数" prop="param_json">
                <el-input
                  v-trim
                  v-model="ruleForm.param_json"
                  placeholder="请输入参数"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="显示字段" prop="show_field_name">
                <el-input
                  v-trim
                  v-model="ruleForm.show_field_name"
                  placeholder="请输入显示字段"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="值字段" prop="value_field_name">
                <el-input
                  v-trim
                  v-model="ruleForm.value_field_name"
                  placeholder="请输入值字段"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="关键字" prop="keyword">
                <el-input
                  v-trim
                  v-model="ruleForm.keyword"
                  placeholder="请输入关键字"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注" prop="data_desc">
                <el-input
                  v-trim
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  v-model="ruleForm.data_desc"
                  placeholder="请输入内容"
                  type="textarea"
                  resize="none"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button v-waves @click="dialogVisible = false">取 消</el-button>
          <el-button
            v-waves
            :loading="loading"
            type="primary"
            @click="handleDiaSure"
          >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </el-dialog>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import Contextmenu from '@/components/Contextmenu'
import waves from '@/directive/waves' // Waves directive
import {
  GetDataSourcelist,
  AddDataSource,
  UpdateDataSource,
  DeleteDataSource,
  GetSearchToolDataSourceUseList
} from '@/api/system'
import { GetBaseData } from '@/api/common'

export default {
  name: 'DataSourceConfiguration',
  components: { Pagination, Contextmenu },
  directives: { waves },
  props: {
    height: {
      type: Number,
      default:process.env.BASE_HEIGHT
    }
  },
  data() {
    return {
      tableKey: 0,
      total: 0,
      listLoading: false, // 加载loading
      loading: false,
      dialogFormVisible: false,
      activeTableRow: {},
      dialogVisible: false,
      listQuery: {
        page_size: 50,
        page_no: 1,
        shop_no: '',
        order_by: '',
        direction: ''
      }, // 搜索条件
      list: [],
      ruleForm: {
        method: 'GET',
        api_name: '',
        data_name: '',
        param_json: '',
        show_field_name: '',
        value_field_name: '',
        data_desc: '',
        data_source_code: '',
        keyword: ''
      },
      rules: {
        data_name: [
          {
            required: true,
            message: '请选择查询名称',
            trigger: ['change', 'blur']
          }
        ],
        method: [
          {
            required: true,
            message: '请选择请求方式',
            trigger: ['change', 'blur']
          }
        ],
        api_name: [
          {
            required: true,
            message: '请选择接口',
            trigger: ['change', 'blur']
          }
        ],
        show_field_name: [
          {
            required: true,
            message: '请输入显示字段',
            trigger: ['change', 'blur']
          }
        ],
        value_field_name: [
          {
            required: true,
            message: '请输入值字段',
            trigger: ['change', 'blur']
          }
        ],
        data_source_code: [
          {
            required: true,
            message: '请输入数据源code',
            trigger: ['change', 'blur']
          }
        ]
      },
      multipleSelection: [] || undefined,
      type: 'create',
      baseInfo: {}
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      GetBaseData({
        codetypes:
          'HttpMethod'
      }).then((response) => {
        if (response.data.res_status_code == 0) {
          this.baseInfo = response.data.res_content
        } else {
          this.$message({
            type: 'error',
            message: response.data.res_message
          })
        }
      })
    },
    // 获取查询列表数据
    async getList() {
      this.listLoading = true
      const response = await GetDataSourcelist(this.listQuery)
      if (response.data.res_status_code == 0) {
        this.list = response.data.res_content.data_list
        this.total = response.data.res_content.total_count
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.bodyWrapper.scrollTop = 0
        }
      } else {
        this.$message.error(response.data.res_message)
      }
      this.listLoading = false
    },
    // 弹窗打开
    async handleOpenDialog() {
      this.dialogFormVisible = true
      this.listLoading = true
      this.listQuery.ids = this.ids
      this.listQuery.approval_id = this.approval_id
      const listQuery = Object.assign({}, this.listQuery)
      if (listQuery.sync_status) {
        listQuery.sync_status = listQuery.sync_status.join(',')
      }
      this.getList()
    },
    // 确定选择
    handleSure() {
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        this.$message.warning('请先选择')
        return
      }
      this.$emit('getDataSource', this.multipleSelection)
      this.dialogFormVisible = false
    },
    sortChange(data) {
      const { prop, order } = data
      if (order == 'descending') {
        this.listQuery.direction = 'desc'
      } else if (order == 'ascending') {
        this.listQuery.direction = 'asc'
      } else {
        this.listQuery.direction = ''
      }
      this.listQuery.order_by = prop
      this.getList()
    },
    // 编辑
    handleEditBtn(row) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.type = 'edit'
        this.ruleForm = Object.assign({}, row)
      })
    },
    // 删除
    async handleDel(id) {
      try {
        const res = await GetSearchToolDataSourceUseList({ id })
        if (res.data.res_status_code == 0) {
          res.data.res_content.forEach(item => {
            this.words = item
              ? `此数据源已经在${res.data.res_content.toString()}页面使用。确定删除？`
              : '确认删除?'
          })
        } else {
          this.$message.error(response.data.res_message)
        }
        await this.$confirm(this.words, '确认删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        const response = await DeleteDataSource({ id })
        if (response.data.res_status_code == 0) {
          this.$message.success('删除成功!')
          this.getList()
        } else {
          this.$message.error(response.data.res_message)
        }
      } catch (err) {
        this.$message.info('已取消删除')
      }
    },
    handleFilter() {
      this.listQuery.page_no = 1
      this.getList()
    },
    handleSelectionChange(val) {
      if (val.length > 1) {
        this.$refs.multipleTable.clearSelection()
        this.$refs.multipleTable.toggleRowSelection(val.pop())
      } else {
        this.multipleSelection = val.pop()
      }
    },
    // 点击行触发，选中或补选中复选框
    handleRowClick(row, column, event) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    openMenu(row, column, event) {
      this.$refs.menu.openMenu(row, column, event)
      this.activeTableRow = row
    },
    // 新增
    handleAdd() {
      this.dialogVisible = true
      this.type = 'create'
      this.$nextTick(() => {
        this.$refs['ruleForm'].resetFields()
      })
    },
    // 确定新增/编辑
    handleDiaSure() {
      this.$refs['ruleForm'].validate(async valid => {
        if (valid) {
          this.loading = true
          let response
          if (this.type && this.type == 'create') { response = await AddDataSource(this.ruleForm) }
          if (this.type && this.type == 'copy') { response = await AddDataSource(this.ruleForm) }
          if (this.type && this.type == 'edit') { response = await UpdateDataSource(this.ruleForm) }
          if (response.data.res_status_code == 0) {
            this.dialogVisible = false
            this.getList()
            this.$message.success('保存成功')
          } else {
            this.$message.error(response.data.res_message)
          }
          this.loading = false
        } else {
          return false
        }
      })
    },
    // 复制
    handleCopy(activeTableRow) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.type = 'copy'
        this.ruleForm = Object.assign({}, activeTableRow)
        this.ruleForm.id = ''
        this.ruleForm.data_source_code = ''
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ {
  .el-dialog {
    width: 80%;
  }
  .el-checkbox:last-of-type {
    margin-left: 15px !important;
    line-height: 28px;
  }
  .el-dialog .dataForm .el-form-item__content .el-input {
    width: 80%;
  }
  .el-textarea {
    width: 80%;
  }
  .el-dialog .el-form-item {
    margin-left: 10px;
  }
  .footer {
    text-align: right;
    padding-bottom: 10px;
    padding-top: 10px;
  }
  .ico {
    font-size: 16px;
    margin-top: 1px;
  }
  .el-checkbox__inner {
    margin-left: -7px;
  }
}
</style>
